/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export const getOneWhatsNew = async (id) => {
  try {
    const url = generateApiUrl(["profile", "whats_new_id"], [id]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);

    return {
      version: pathOr(null, ["whats_new_version"], data),
      changeType: pathOr(null, ["change_type"], data),
      taskNumber: pathOr(null, ["task_number"], data),
      description: pathOr(null, ["description"], data),
    };
  } catch (error) {
    throw error;
  }
};
export const addWhatsNew = async (
  versionId,
  changeTypeId,
  taskNumber,
  description
) => {
  try {
    const url = generateApiUrl(["profile", "whats_new"]);
    const payload = {
      whats_new_version_id: versionId,
      change_type_id: changeTypeId,
      task_number: taskNumber,
      description,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const editWhatsNew = async (
  id,
  versionId,
  changeTypeId,
  taskNumber,
  description
) => {
  try {
    const url = generateApiUrl(["profile", "whats_new_id"], [id]);
    const payload = {
      whats_new_version_id: versionId,
      change_type_id: changeTypeId,
      task_number: taskNumber,
      description,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const deleteWhatsNew = async (id) => {
  try {
    const url = generateApiUrl(["profile", "whats_new_id"], [id]);
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
